export default __webpack_public_path__ + "static/media/featured-pink.96c6d2b8.svg";